export const NOTE_EVENTS = {
    CREATED: 'note.created',
    REPLIED: 'note.replied',
    MENTION: 'note.mention',
};
